import React from "react";
import AllSalesOrders from "./SalesOrderModule/AllSalesOrders";

const SalesOrders = () => {
  return (
    <div>
      <AllSalesOrders />
    </div>
  );
};

export default SalesOrders;
